var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2h4c1.66 0 3 1.34 3 3 0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1 0-1.66 1.34-3 3-3zM17 15.75h-1V19c0 1.66-1.34 3-3 3h-2c-1.66 0-3-1.34-3-3v-3.25H7c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h10c.41 0 .75.34.75.75s-.34.75-.75.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7c-2 0-3 1-3 3v5c0 2 1 3 3 3h.375c.345 0 .625-.28.625-.625v-.126a.8.8 0 0 0-.424-.706C5.692 16.07 5.25 15.557 5.25 15c0-.96.79-1.75 1.75-1.75h10c.96 0 1.75.79 1.75 1.75s-.79 1.75-1.75 1.75v.45a.8.8 0 0 0 .8.8h.2c2 0 3-1 3-3v-5c0-2-1-3-3-3H6zm1 4.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75H7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPrinter);
export default __webpack_public_path__ + "static/media/vuesax-bold-printer.6e3c3d5e9b5aab7c09ae6e2c7e7bf574.svg";
export { ForwardRef as ReactComponent };